import {gql} from "@apollo/client";

export const PING_EXPORT = gql`
    query pingExport($fromPath: String!){
        res: pingExport(fromPath: $fromPath)
    }
`;
